<template>
    <v-dialog
        :value="isOpen"
        max-width="600px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                Domawianie płyt
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-select
                            v-model="plateOrderReason"
                            :items="plateOrderReasons"
                            item-value="id"
                            item-text="reason"
                            placeholder="Przyczyna"
                            label="Przyczyna"
                            return-object
                            no-data-text="Brak procesów"
                            dense
                            outlined
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col 
                        v-if="plates.length > 0"
                        cols="12"
                        sm="12"
                        class="d-flex"
                    >
                        <template
                            v-for="(plate, index) in plates"
                        >
                            <v-col v-if="index > 0" :key="index + 'divider'" cols="12" sm="2" class="d-flex justify-center">
                                <v-divider
                                    vertical
                                />
                            </v-col>
                            <v-col :key="plate.name" cols="12" sm="5">
                                <div class="text-subtitle-1">
                                    {{ plate.name }}
                                </div>
                                <v-checkbox
                                    v-for="color in getColoursList(plate.value)"
                                    :key="color"
                                    v-model="selectedPlates"
                                    :label="color"
                                    :value="getPlateSide(plate.name) + '|' + color"
                                />
                            </v-col>
                        </template>
                    </v-col>
                    <v-col v-else cols="12">
                        <v-alert
                            type="error"
                            text
                            border="left"
                        >
                            Brak konfiguracji kolorystyki
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    class="ma-2"
                    :disabled="!plateOrderReason || !selectedPlates.length"
                    @click="createOrderPlates"
                >
                    Zamów
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'OrderAdditionalBoardsDialog',

    props: {
        isOpen: {
            type: Boolean
        },
        machineCode: {
            type: String,
            required: true
        },
        reportData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            plates: [],
            selectedPlates: [],
            plateOrderReason: null,
        }
    },
    computed: {
        userFirstName() {
            return this.$store.state.user.userFirstName
        },
        userLastName() {
            return this.$store.state.user.userLastName
        },
        reportItemId() {
            return this.reportData.objectDetail.reportItemId
        },
        plateOrderReasons() {
            return this.$store.state.reports.reporting.plateOrderReasons
        },
    },
    mounted() {
        this.$store.dispatch('reports/getPlateOrderReasons')
            .catch(error => {
                errorHandler(error)
            })

        this.getReportItemColours()
    },
    methods: {
        onClose() {
            this.$emit('on-close')

            setTimeout(() => {
                this.selectedPlates = []
                this.plateOrderReason = null
            }, 500)
        },
        getReportItemColours() {
            this.$store.dispatch('reports/getReportItemColours', this.reportItemId)
                .then(({data}) => {
                    this.plates = data.colours
                })
                .catch(error => {
                    errorHandler(error)
                })

        },
        getColoursList(colours) {
            return colours.split(',').map(colour => colour.trim())
        },
        getPlateSide(plateName) {
            return plateName.replace(/kolorystyka strona/gi, '').trim()
        },
        createOrderPlates() {
            let payload = {
                jobNumber: this.reportData.objectNumber,
                machineCode: this.machineCode,
                plateNumber: this.reportData.plateNumber,
                plateOrderReasonsIds: [this.plateOrderReason.id],
                createdByFirstName: this.userFirstName,
                createdByLastName: this.userLastName,
                plateOrderItems: this.selectedPlates.map(plate => {
                    const [side, colour] = plate.split('|')

                    return { side, colour }
                })
            }

            this.$store.dispatch('reports/createPlatesOrder', payload)
                .then(() => {
                    this.onClose()
                })
                .catch(error => {
                    errorHandler(error)
                })
        }
    }
}
</script>